
import * as React from 'react';
import { ToggleSwitch } from 'common--design-library';
import { translationForMts } from 'easit--localization';
import * as classNames from 'classnames';

export interface IOTBSwitchProps {
    isOTBOn: boolean;
    isOTBActive: boolean;
    switchColor: string;
    toggleOTB: (isOn: boolean) => void;
}

export const OTBSwitch: React.FC<IOTBSwitchProps> = (props: IOTBSwitchProps) => {
    return <div className={classNames("otb-switch-wrapper", props.isOTBActive && "otb-active")}>
        <span>{translationForMts().otb_Switch}</span>
        <span><ToggleSwitch
            onToggle={(v) => { props.toggleOTB(v); }}
            value={props.isOTBOn}
            selectedColor={props.switchColor}
        /></span>
    </div>
}